module.exports = __webpack_public_path__ + "static/media/Pic-0315.83814c5d.jpg";